@if (isLoading()) {
  <div class="spinner-overlay" role="status" aria-live="polite">
    <mat-spinner></mat-spinner>
  </div>
}